<div class="fees-retrieve-wrapper">

  <div class="header">
    <h2>Fee Items</h2>
    <p>Filter and view school fee structures</p>
  </div>

  <!-- FILTER BAR -->
  <div class="filter-card">

    <div class="filter-group">
      <label>Academic Year</label>
      <select [(ngModel)]="scope.academicYear" (change)="onScopeChange()">
        <option *ngFor="let y of academicYears" [value]="y">{{ y }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>Semester</label>
      <select [(ngModel)]="scope.semester" (change)="onScopeChange()">
        <option value="SEM1">Semester 1</option>
        <option value="SEM2">Semester 2</option>
      </select>
    </div>

    <div class="filter-group">
      <label>Student Type</label>
      <select [(ngModel)]="scope.studentType" (change)="onScopeChange()">
        <option value="GHANAIAN">Ghanaian</option>
        <option value="INTERNATIONAL">International</option>
      </select>
    </div>

    <div class="filter-actions">
      <span *ngIf="isCurrentScope" class="badge-current">Current</span>
      <button *ngIf="!isCurrentScope" (click)="resetToLatest()">Reset</button>
    </div>

  </div>

  <!-- ERROR -->
  <div class="error" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <!-- TABLE -->
  <div class="table-card">

    <div *ngIf="loading" class="loading">Loading...</div>

    <table *ngIf="!loading && feeItems.length > 0">
      <thead>
        <tr>
          <th>Label</th>
          <th>Amount (₵)</th>
          <th>Student Type</th>
          <th>Year</th>
          <th>Semester</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of feeItems">
          <td>{{ item.label }}</td>
          <td>₵ {{ item.amount | number:'1.2-2' }}</td>
          <td>{{ item.studentType }}</td>
          <td>{{ item.academicYear }}</td>
          <td>{{ item.semester }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="1">TOTAL</td>
          <td>₵ {{ totalAmount | number:'1.2-2' }}</td>
          <td colspan="3"></td>
        </tr>
      </tfoot>
    </table>

    <div *ngIf="!loading && feeItems.length === 0" class="empty">
      No fee items found
    </div>

  </div>

</div>